import { DateTime } from "luxon";
import { ResponseTimeGranularity } from "../constant/ResponseTimeGranularity";
import { GetWfsResponseTimeRequest } from "../types/WfsLog/GetWfsResponseTimeRequest";

export default class GetWfsResponseTimeRequestService {
  public getDefaultRequest = (
    granularity?: ResponseTimeGranularity,
    request?: GetWfsResponseTimeRequest
  ): GetWfsResponseTimeRequest => {
    // 30 Days - Last 12 months
    // 7 Days  - Last 12 weeks
    // One Day - Last 2 weeks
    // Six Hours - Last 3 days
    // One Hour - Last 12 hours.
    // 15 minutes - Last four hours
    // 5 minutes - Last hour
    // 1 minute - Last 30 minutes
    // 30 seconds - last 15 mins

    if (!request) {
      request = {
        startDate: DateTime.now().startOf("day"),
        endDate: DateTime.now(),
        granularity: ResponseTimeGranularity.OneDay,
      };
    }

    if (!granularity) {
      granularity = ResponseTimeGranularity.OneDay;
    }

    switch (granularity) {
      case ResponseTimeGranularity.ThirtyDays:
        return {
          ...request,
          granularity: granularity,
          startDate: DateTime.now().minus({ months: 30 }).startOf("day"),
          endDate: DateTime.now(),
        };
      case ResponseTimeGranularity.SevenDays:
        return {
          ...request,
          granularity: granularity,
          startDate: DateTime.now().minus({ weeks: 12 }).startOf("day"),
          endDate: DateTime.now(),
        };

      case ResponseTimeGranularity.OneDay:
      default:
        return {
          ...request,
          granularity: granularity,
          startDate: DateTime.now().minus({ weeks: 2 }).startOf("day"),
          endDate: DateTime.now(),
        };
      case ResponseTimeGranularity.SixHours:
        return {
          ...request,
          granularity: granularity,
          startDate: DateTime.now().minus({ days: 3 }).startOf("day"),
          endDate: DateTime.now(),
        };

      case ResponseTimeGranularity.OneHour:
        return {
          ...request,
          granularity: granularity,
          startDate: DateTime.now().minus({ hours: 12 }),
          endDate: DateTime.now(),
        };

      case ResponseTimeGranularity.FifteenMinutes:
        return {
          ...request,
          granularity: granularity,
          startDate: DateTime.now().minus({ hours: 4 }),
          endDate: DateTime.now(),
        };

      case ResponseTimeGranularity.FiveMinutes:
        return {
          ...request,
          granularity: granularity,
          startDate: DateTime.now().minus({ hours: 1 }),
          endDate: DateTime.now(),
        };

      case ResponseTimeGranularity.OneMinute:
        return {
          ...request,
          granularity: granularity,
          startDate: DateTime.now().minus({ minutes: 30 }),
          endDate: DateTime.now(),
        };

      case ResponseTimeGranularity.ThirtySeconds:
        return {
          ...request,
          granularity: granularity,
          startDate: DateTime.now().minus({ minutes: 15 }),
          endDate: DateTime.now(),
        };
    }
  };

  public getDateLabel = (
    date: DateTime,
    request: GetWfsResponseTimeRequest
  ) => {
    switch (request.granularity) {
      case ResponseTimeGranularity.ThirtyDays:
      case ResponseTimeGranularity.SevenDays:
      case ResponseTimeGranularity.OneDay:
        return date.toFormat("dd/MM/yyyy");
      case ResponseTimeGranularity.SixHours:
        return date.toFormat("dd/MM/yyyy HH:00");
      case ResponseTimeGranularity.OneHour:
      case ResponseTimeGranularity.FifteenMinutes:
      case ResponseTimeGranularity.FiveMinutes:
        return date.toFormat("dd/MM/yyyy HH:mm");
      case ResponseTimeGranularity.OneMinute:
        return date.toFormat("HH:mm");
      case ResponseTimeGranularity.ThirtySeconds:
        return date.toFormat("HH:mm:ss");
    }
  };

  public getGranularityLabel = (granularity: ResponseTimeGranularity) => {
    switch (granularity) {
      case ResponseTimeGranularity.ThirtyDays:
        return "30 Days";
      case ResponseTimeGranularity.SevenDays:
        return "7 Days";
      case ResponseTimeGranularity.OneDay:
        return "1 Day";
      case ResponseTimeGranularity.SixHours:
        return "6 Hours";
      case ResponseTimeGranularity.OneHour:
        return "1 Hour";
      case ResponseTimeGranularity.FifteenMinutes:
        return "15 Minutes";
      case ResponseTimeGranularity.FiveMinutes:
        return "5 Minutes";
      case ResponseTimeGranularity.OneMinute:
        return "1 Minute";
      case ResponseTimeGranularity.ThirtySeconds:
        return "30 Seconds";
    }
  };

  public granularityOptions = [
    {
      label: "30 Secs",
      value: ResponseTimeGranularity.ThirtySeconds,
    },
    {
      label: "1 min",
      value: ResponseTimeGranularity.OneMinute,
    },
    {
      label: "5 mins",
      value: ResponseTimeGranularity.FiveMinutes,
    },
    {
      label: "15 mins",
      value: ResponseTimeGranularity.FifteenMinutes,
    },
    {
      label: "1 hour",
      value: ResponseTimeGranularity.OneHour,
    },
    {
      label: "6 hours",
      value: ResponseTimeGranularity.SixHours,
    },
    {
      label: "1 day",
      value: ResponseTimeGranularity.OneDay,
    },
    {
      label: "7 days",
      value: ResponseTimeGranularity.SevenDays,
    },
    {
      label: "30 days",
      value: ResponseTimeGranularity.ThirtyDays,
    },
  ];
}
